import { render, staticRenderFns } from "./DisplayName.vue?vue&type=template&id=23c2eb68&scoped=true&"
import script from "./DisplayName.vue?vue&type=script&lang=js&"
export * from "./DisplayName.vue?vue&type=script&lang=js&"
import style0 from "./DisplayName.vue?vue&type=style&index=0&id=23c2eb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2eb68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c2eb68')) {
      api.createRecord('23c2eb68', component.options)
    } else {
      api.reload('23c2eb68', component.options)
    }
    module.hot.accept("./DisplayName.vue?vue&type=template&id=23c2eb68&scoped=true&", function () {
      api.rerender('23c2eb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/DisplayName.vue"
export default component.exports